import * as Sentry from '@sentry/browser';
import { httpClient } from '@/httpClient/axios.ts';

interface GetEventRequestProps {
  url: string;
}

export const getEventRequest = ({ url }: GetEventRequestProps) => {
  return httpClient
    .get(url)
    .then((res) => {
      return res.data.events;
    })
    .catch((e) => {
      Sentry.captureException(e);
    });
};
